/* =============================================================
   Plek in Bloei — productpagina
   Galerij, varianten, aantal, vaste koopbalk, beeldvergroting.
   ============================================================= */

(function (PIB) {
  'use strict';

  /* ---- aantalkiezer ---- */

  PIB.register('aantal', function (root) {
    root.querySelectorAll('.aantal').forEach(function (blok) {
      if (blok.closest('.laderij')) return;            // de lade regelt dat zelf
      if (!PIB.eenmalig(blok, 'aantalGebonden')) return;

      var invoer = blok.querySelector('input');
      if (!invoer) return;

      blok.querySelectorAll('button').forEach(function (knop) {
        knop.addEventListener('click', function () {
          var min = parseInt(invoer.min, 10) || 1;
          var nu = parseInt(invoer.value, 10) || min;
          invoer.value = Math.max(min, nu + (knop.dataset.stap === 'min' ? -1 : 1));
          invoer.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  });

  /* ---- productgalerij ---- */

  PIB.register('galerij', function (root) {
    root.querySelectorAll('[data-galerij]').forEach(function (galerij) {
      if (!PIB.eenmalig(galerij, 'galerijGebonden')) return;

      var hoofd = galerij.querySelector('[data-galerij-hoofd]');
      if (!hoofd) return;

      var miniaturen = galerij.querySelectorAll('[data-galerij-mini]');

      miniaturen.forEach(function (mini) {
        mini.addEventListener('click', function () {
          hoofd.src = mini.dataset.groot;
          hoofd.srcset = mini.dataset.grootSrcset || '';
          hoofd.alt = mini.dataset.alt || '';
          miniaturen.forEach(function (m) { m.setAttribute('aria-current', String(m === mini)); });
        });
      });
    });
  });

  /* ---- varianten ---- */

  PIB.register('varianten', function (root) {
    root.querySelectorAll('[data-variant-kiezer]').forEach(function (kiezer) {
      if (!PIB.eenmalig(kiezer, 'variantGebonden')) return;

      var bron = kiezer.querySelector('[data-varianten-json]');
      if (!bron) return;

      var varianten;
      try { varianten = JSON.parse(bron.textContent); } catch (e) { return; }

      var formulier = kiezer.closest('form');
      var idVeld = document.getElementById(kiezer.dataset.idVeld);
      var prijsVeld = document.getElementById(kiezer.dataset.prijsVeld);
      var voorraadVeld = document.getElementById(kiezer.dataset.voorraadVeld);
      var knoppen = document.querySelectorAll('[data-koop-knop]');

      function gekozenOpties() {
        return Array.prototype.map.call(kiezer.querySelectorAll('fieldset'), function (set) {
          var aan = set.querySelector('input:checked');
          return aan ? aan.value : null;
        });
      }

      function bijwerken() {
        var opties = gekozenOpties();

        var match = varianten.filter(function (v) {
          return opties.every(function (waarde, i) { return waarde === null || v.options[i] === waarde; });
        })[0];

        if (!match) {
          knoppen.forEach(function (k) { k.disabled = true; k.textContent = k.dataset.labelNietBeschikbaar; });
          return;
        }

        if (idVeld) idVeld.value = match.id;
        if (prijsVeld && match.prijs_html) prijsVeld.innerHTML = match.prijs_html;

        if (voorraadVeld) {
          voorraadVeld.textContent = match.available ? (match.voorraad_tekst || '') : (voorraadVeld.dataset.uitverkocht || '');
          voorraadVeld.classList.toggle('product__voorraad--op', !match.available);
        }

        knoppen.forEach(function (k) {
          k.disabled = !match.available;
          k.textContent = match.available ? k.dataset.labelKopen : k.dataset.labelUitverkocht;
        });

        if (match.media_src) {
          var hoofd = document.querySelector('[data-galerij-hoofd]');
          if (hoofd) { hoofd.src = match.media_src; hoofd.srcset = ''; }
        }

        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      }

      kiezer.addEventListener('change', bijwerken);
      if (formulier) bijwerken();
    });
  });

  /* ---- vaste koopbalk op mobiel ---- */

  PIB.register('koopbalk', function (root) {
    var balk = root.querySelector('.koopbalk') || document.querySelector('.koopbalk');
    if (!balk || !PIB.eenmalig(balk, 'balkGebonden')) return;

    var anker = document.querySelector('.product__koop [data-koop-knop]');
    if (!anker || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (regels) {
      regels.forEach(function (regel) {
        balk.classList.toggle('is-zichtbaar', !regel.isIntersecting && regel.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(anker);
  });

  /* ---- beeld vergroten ---- */

  PIB.register('vergroting', function () {
    var doos = document.getElementById('vergroting');
    if (!doos || !PIB.eenmalig(doos, 'vergrootGebonden')) return;

    var beeld = doos.querySelector('img');

    function toon(bron) {
      var doel = bron.querySelector('img') || bron;
      if (!doel.src) return;
      beeld.src = doel.src;
      beeld.alt = doel.alt || '';
      PIB.open('vergroting');
    }

    document.addEventListener('click', function (e) {
      var bron = e.target.closest('[data-vergroot]');
      if (bron) toon(bron);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var bron = e.target.closest('[data-vergroot]');
      if (!bron) return;
      e.preventDefault();
      toon(bron);
    });
  });
})(window.PIB);
